import { render, staticRenderFns } from "./zizhi.vue?vue&type=template&id=047b93ad&"
import script from "./zizhi.vue?vue&type=script&lang=js&"
export * from "./zizhi.vue?vue&type=script&lang=js&"
import style0 from "./zizhi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports